import OrganizationBrowser from "./OrganizationBrowser";

export default OrganizationBrowser;
